export default "__VITE_ASSET__b4644529__"